<div class="container">
    <textarea rows="20">{{ content | json }}</textarea>
    <div>
        <app-regular-button [title]="'Fechar'" (click)="close()" [secondary]="true"></app-regular-button>
    </div>
</div>